import "@/../../shared/app/assets/scss/soft-ui.scss";
export default {};
